import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UpgradeButton from 'components/Buythrough/UpgradeButton';
import { redirectToExternalUrl } from 'helpers/RouteHelper';
import { amplitudeTestName, EXPERIMENTS } from 'helpers/AmplitudeHelper';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';

export const SERIES_DETAIL_OVERLAY = 'SERIES_DETAIL_OVERLAY';
export const PLAYABLE_OVERLAY = 'PLAYABLE_OVERLAY';
export const Overlay = props => {
  const {
    ariaLabel,
    children,
    isHoverStateV2,
    isSeries,
    isUpcoming,
    playButtonClick,
    showUpgradeCTA = false,
    theme,
    type,
  } = props;

  const ariaLabelText = ariaLabel ? `play ${ariaLabel}` : 'play button';
  const { blackFridaySignUpUrl, signUpUrl } = window.ExternalConfig;
  const { upsellPromoNavCTA } = window.Language;
  const pageTestName = amplitudeTestName(EXPERIMENTS.WEB_ANON_CTA);

  switch (type) {
    case SERIES_DETAIL_OVERLAY:
      return (
        <div
          className={classNames(theme.playButtonOverlay, theme.playButtonScale)}
          onClick={playButtonClick}
        >
          <div className={classNames([theme.playButton])}>{children}</div>
        </div>
      );
    case PLAYABLE_OVERLAY:
      return (
        <div
          className={classNames(
            theme.playButtonOverlay,
            isHoverStateV2 && !isUpcoming && !isSeries && theme.playButtonOverlayHoverStateV2,
          )}
        >
          {showUpgradeCTA ? (
            <UpgradeButton
              isResumeButton={false}
              isFreemium={false}
              data-test="upgrade-button"
              onClick={({ isJoinNow }) => {
                handleAnalytics({
                  event: Events.UPGRADE_NOW_BUTTON_CLICKED,
                  payload: {
                    page_item_title: upsellPromoNavCTA,
                    page_test_name: pageTestName,
                    page_action_location: 'anonymous series detail page',
                  },
                });
                redirectToExternalUrl(isJoinNow ? blackFridaySignUpUrl : signUpUrl);
              }}
            >
              {!isUpcoming && !isSeries && children}
            </UpgradeButton>
          ) : (
            <div
              aria-label={ariaLabelText}
              className={classNames([
                theme.playButton,
                isHoverStateV2 && theme.playButtonV2,
                isHoverStateV2 && (isSeries || isUpcoming) && theme.playableShowTile,
              ])}
              onClick={playButtonClick}
            >
              {!isUpcoming && !isSeries && children}
            </div>
          )}
        </div>
      );
    default:
      return null;
  }
};

Overlay.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  isHoverStateV2: PropTypes.bool,
  isSeries: PropTypes.bool,
  isUpcoming: PropTypes.bool,
  originalItem: PropTypes.shape({}),
  playButtonClick: PropTypes.func,
  showUpgradeCTA: PropTypes.bool,
  theme: PropTypes.shape({}),
  type: PropTypes.string,
};
